import { render, staticRenderFns } from "./CustomerNavigation.vue?vue&type=template&id=c338940c&scoped=true"
var script = {}
import style0 from "./CustomerNavigation.vue?vue&type=style&index=0&id=c338940c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c338940c",
  null
  
)

export default component.exports